import React from 'react';
import { useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';

import MainTemplate from 'pages/templates/MainTemplate';
import { displayFilterList } from 'constants/resources/commonCustomize';

import MbTabs from 'components/organisms/MbTabs';

import Statistics from './Statistics'; //T-time별 통계(변수별)
import FreqTtimeStatistics from './FreqTtimeStatistics'; //T-time별 통계(전략별)
import FreqStatistics from './FreqStatistics';
import FreqSttStatistics from './FreqSttStatistics';
import FreqCrossStatistics from './FreqCrossStatistics';

const FrequencyStatistics = () => {
  let { path } = useRouteMatch();
  const { menu } = useSelector(({ menu }) => ({
    menu: menu.list === null ? new Map() : menu.list,
  }));

  const tabList = () => {
    for (let curMenu of menu.values()) {
      if (typeof curMenu.subMenu !== 'undefined') {
        const cur = curMenu.subMenu.get(path);
        if (typeof cur !== 'undefined') {
          // 현재 2dapth url에 매칭되는 것이 있으면 그 메뉴의 하위 tab 반환
          return cur.subMenu;
        }
      }
    }
  };

  return (
    <MainTemplate>
      <MbTabs
        name="FrequencyStatistics"
        tabMenuList={tabList()}
        tabs={{
          '/report/freq/graph': {
            tabComponent: (
              <>
                <FreqStatistics />
              </>
            ),
          },
          '/report/freq/graphStt': {
            tabComponent: (
              <>
                <FreqSttStatistics />
              </>
            ),
          },
          '/report/freq/graphCross': {
            tabComponent: (
              <>
                <FreqCrossStatistics
                  displayFilterList={displayFilterList.freq}
                />
              </>
            ),
          },
          '/report/freq/ttimegraph': {
            tabComponent: (
              <>
                <Statistics switchDatas={['01', '02']} graphType="02" />
              </>
            ),
          },
          '/report/freq/ttimegraphStt': {
            tabComponent: (
              <>
                <FreqTtimeStatistics switchDatas={['01', '02']} />
              </>
            ),
          },
        }}
      />
    </MainTemplate>
  );
};

export default FrequencyStatistics;
